// extracted by mini-css-extract-plugin
export default {"music-card-list":"MusicShelfList_music-card-list__7tbeo","music-card-carousel-list":"MusicShelfList_music-card-carousel-list__AeJol","slider":"MusicShelfList_slider__lnFOa"};